export default {
  POST_CORRECT_PREDICTION: "POST_CORRECT_PREDICTION",
  POST_INCORRECT_PREDICTION: "POST_INCORRECT_PREDICTION",
  POST_MAYBE_PREDICTION: "POST_MAYBE_PREDICTION",
  GET_ALL_PREDICTION: "GET_ALL_PREDICTION",
  SET_RULE_DIALOG_OPEN: "SET_RULE_DIALOG_OPEN",
  SET_RULE_TO_EDIT: "SET_RULE_TO_EDIT",
  SAVE_ASTRO_RULE: "SAVE_ASTRO_RULE"
};
